import { api as awsApi } from './aws';

const API_DEFAULT_METHODS = [
  'get',
  'post',
  'put',
  'delete',
];

export const CLIENT_VER='20260407.2';

const createApi = (opts) => {
  const api = {
    baseUrl: opts.baseUrl ? `/${trimSlashes(opts.baseUrl)}` : '',
    headers: opts.headers || {},
    raw: opts.raw
  };

  API_DEFAULT_METHODS.forEach(methodName => {
    api[methodName] = async (path, params, headers) => {
      path = trimSlashes(path || '');
      headers = Object.assign({}, api.headers, headers);

      return request({
        url: `${api.baseUrl}/${path}`,
        method: methodName === 'delete' ? 'del' : methodName,
        query: methodName === 'get' ? params : null,
        body: methodName === 'get' ? null : params,
        headers,
        raw: opts.raw
      });
    };
  });

  return api;
};

const request = async ({ url, method = 'get', query, body, headers = {}, raw = false }) => {
  let res = {};
  try {
    if(body)
      body.client_ver = CLIENT_VER;
    else if(query)
        query.client_ver = CLIENT_VER;
    else
      query = { client_ver: CLIENT_VER};

    res = await awsApi[method]('lambda', url, {
      headers,
      queryStringParameters: query,
      body,
    });

    console.log(`Response for ${method} ${url}:`, res);
  } catch (err) {
    console.log(err);

    if(raw)
      throw err;
  }

  if (!res.Success) {
    //throw new Error(res.Error || 'Something went wrong!');
    console.log("Api error - "+JSON.stringify(res));

    if(raw)
      return res;
    else
      return null;
  }

  return res.Payload;
};

const trimSlashes = path => path.replace(/^\/+|\/+$/gm, '');

export default createApi;
